import { gql } from '@apollo/client';

import {
  CreateMobileAudioUploadUrlDocument,
  type CreateMobileAudioUploadUrlMutation,
  type CreateMobileAudioUploadUrlMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation CreateMobileAudioUploadUrl(
      $input: CreateMobileAudioUploadUrlInput!
    ) {
      createMobileAudioUploadUrl(input: $input) {
        url
        publicUrl
        path
      }
    }
  `;
}

export const CREATE_MOBILE_AUDIO_UPLOAD_URL =
  CreateMobileAudioUploadUrlDocument;
export type {
  CreateMobileAudioUploadUrlMutation,
  CreateMobileAudioUploadUrlMutationVariables,
};
